import { useEffect, useState } from "react";
import { ConspretratamientoCreate } from "./ConspretratamientoCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

export function ConspretratamientoNew(props) {
  const conspretratamiento = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let conspretratamientoLength = conspretratamiento.length;
  let currentSesion = conspretratamientoLength + 1;

  const [conspretResp, setConspretResp] = useState(props.especialistaFullName);
  const [metaFecha, setConspretFecha] = useState(todayDate);
  const [conspretMedio, setConspretMedio] = useState("");
  const [conspretTipo, setConspretTipo] = useState("");
  const [conspretObs, setConspretObs] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  // Load Especialista and Pacieste Autfill Data
  useEffect(() => {
    const loadAutofillData = async () => {
      // promise settles and return its result
      const especialista = await APIUSER.getCurrentUser();

      let especialistaFullName = especialista
        ? especialista?.first_name + " " + especialista?.last_name
        : "";

      // After fetching data stored it in posts state.
      setConspretResp(especialistaFullName);
    };
    // Call the function
    loadAutofillData();
  }, []);

  console.log(currentSesion);

  const submitConspretratamiento = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      conspretResp,
      metaFecha,
      conspretMedio,
      conspretTipo,
      conspretObs,
      tratamientoId,
      pacienteId
    );
    try {
      await ConspretratamientoCreate(
        conspretResp,
        metaFecha,
        conspretMedio,
        conspretTipo,
        conspretObs,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../consulta-pre-tratamiento/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitConspretratamiento}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='conspretResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='conspretResp'
                  required
                  type='text'
                  value={conspretResp}
                  onChange={(e) => setConspretResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setConspretFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='conspretMedio'>Medio</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='conspretMedio'
                    required
                    name='conspretMedio'
                    defaultValue=''
                    onChange={(e) => setConspretMedio(e.target.value)}
                  >
                    <option disabled value=''>
                      -- Selecciona una opción --
                    </option>
                    <option value='presencial'>Presencial</option>
                    <option value='videoconferencia'>Videoconferencia</option>
                    <option value='telefonico'>Telefónico</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='conspretTipo'>Tipo</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='conspretTipo'
                    required
                    name='conspretTipo'
                    value={conspretTipo}
                    onChange={(e) => setConspretTipo(e.target.value)}
                  >
                    {( props.userRole.includes('administrador')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='medica'>Médica</option>
                      <option value='psicologica'>Psicológica</option>
                      <option value='psiquiatrica'>Psiquiátrica</option>
                      <option value='ypsilon'>Ypsilon ambulatorio</option>
                    </>
                    : ( props.userRole.includes('medicina')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='medica'>Médica</option>
                    </>
                    : ( props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='psicologica'>Psicológica</option>
                      <option value='psiquiatrica'>Psiquiátrica</option>
                      <option value='ypsilon'>Ypsilon ambulatorio</option>
                    </>
                    :
                      <option disabled value=''>Sin Permisos</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='conspretObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='conspretObs'
                id='conspretObs'
                value={conspretObs}
                onChange={(e) => setConspretObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia') || props.userRole.includes('medicina')) && (
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      )}
      </div>
    </>
  );
}
